module.exports = __webpack_public_path__ + "img/L@2x.2134766b.jpg";